import IToken from "interfaces/token";
import { getAuthorizeCodes } from "utils/data-fetching/getAuthorizeCodes";
import { getUserTokens } from "utils/data-fetching/getUserTokens";
import { LOGIN_ERRORS } from "../../../../constants";

const handleReturningUserLogin = async ({
  applicationId,
  saveToken,
  saveCode,
  setFormError,
  setIsPageLoading,
}: {
  applicationId: string | null | undefined;
  saveToken: (tokens: IToken) => void;
  saveCode: (code: string) => void;
  setFormError: (formError: string | null) => void;
  setIsPageLoading: (isPageLoading: boolean) => void;
}) => {
  const queryString = window.location.search;
  const urlSearchParams = new URLSearchParams(queryString);
  if (urlSearchParams.has("code")) {
    const code = urlSearchParams.get("code");
    if (code && code?.length > 0) {
      const tokenData =
        applicationId && (await getUserTokens({ applicationId, code }));

      if (tokenData?.accessToken) {
        const tokensObj = {
          tokens: tokenData,
          status: "", // This is added to deal with a ITokens TS error because the status is not returned from the getUserTokens endpoint.
        };

        saveToken(tokensObj);
      } else {
        setIsPageLoading(false);
      }
    }
  } else {
    try {
      const codeData =
        applicationId && (await getAuthorizeCodes(applicationId));
      if (codeData?.code) {
        saveCode(codeData.code);
      } else {
        setIsPageLoading(false);
      }
    } catch (err) {
      setFormError(LOGIN_ERRORS.DEFAULT.userErrorMessage);
      console.error(`getAuthorizeCode fetch error: ${err}`);
    }
  }
};

export default handleReturningUserLogin;
